// Dana AI ops (ai-agent-service /ai/ops via the gateway). Platform-scoped LLM
// usage/cost observability recorded per call from Anthropic response usage.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);
const B = `${API_V1}/ai/ops`;

export interface AiUsageTotals {
  calls: number;
  input_tokens: number;
  output_tokens: number;
  cost_usd: number;
  avg_latency_ms: number;
  errors: number;
  error_rate: number;
}
export interface DayPoint { day: string; calls: number; cost_usd: number; tokens: number; errors: number }
export interface ModelRow { model: string; calls: number; cost_usd: number; tokens: number }
export interface FeatureRow { feature: string; calls: number; cost_usd: number; tokens: number }
export interface TenantRow { tenant_id: string | null; calls: number; cost_usd: number; tokens: number }
export interface KeySourceRow { key_source: string; calls: number; cost_usd: number; tokens: number }

export interface AiUsage {
  window_days: number;
  totals: AiUsageTotals;
  by_day: DayPoint[];
  by_model: ModelRow[];
  by_feature: FeatureRow[];
  by_key_source: KeySourceRow[];
  top_tenants: TenantRow[];
}

export const getAiUsage = (days = 30) =>
  axios.get<AiUsage>(`${B}/usage`, { params: { days } }).then((r) => r.data);
